// @ts-nocheck
import { Grid, Typography, Box, useTheme } from '@mui/material';
import React from 'react';
import { ReactComponent as NoDataPageImage } from '../../assets/NoDataPageImage.svg';

/**
 * @function NoDataPage
 * @description No Project component to display when there is no project
 * @returns {JSX} ProjectsOverview component
 * @example <NoDataPage history={history} />
 */
const NoDataPage = () => {
  const themes = useTheme();
  return (
    <Box>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        height="calc(100vh - 64px)"
      >
        <Grid
          container
          spacing={4}
          justifyContent="center"
          alignItems="center"
          direction="column"
        >
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            role="img"
          >
            <NoDataPageImage
              style={{
                color: themes.palette.primary.main,
              }}
            />
          </Grid>
          <Grid item>
            <Typography
              overflow="hidden"
              textOverflow="ellipsis"
              whiteSpace="nowrap"
              variant="h6"
              align="center"
              tabIndex={0}
              sx={{
                '&:focus-visible': {
                  outline: 'none',
                  border: `2px solid ${themes?.palette?.primary?.main} !important`,
                },
              }}
            >
              No organization selected. Get started by choosing one from the
              dropdown above.
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};
export default NoDataPage;
